import React, { Component } from "react";
import "./MAMCAActors.css";
import Cookie from 'js-cookie';
import {
    message, ConfigProvider, Divider,
    Popconfirm, Table, Empty, Spin,
    Modal, Button, Form, Input, Tooltip,
    Steps, Row, Col, Badge, Icon, Select, Alert,
} from 'antd';
import { Link } from "react-router-dom";

const { Option } = Select;


//create actor modal
const CreateForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {
            const {
                visible, onCancel, onCreate, form
            } = this.props; //read all the property send from Alternative

            const { getFieldDecorator } = form; //can get the input value
            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Create a new actor"
                    okText="Create"
                    onCancel={onCancel}
                    onOk={onCreate}
                >

                    <Alert message="Kindly refrain from including periods (.) in the name field." type="info" showIcon />

                    <Form layout="vertical">
                        <Form.Item label="Actor group name">
                            {getFieldDecorator('actorGroupName', {
                                rules: [
                                    { required: true, message: 'Please input the name of actor!' }
                                ], //set the rule
                            })(
                                <Input />
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
            );
        }
    }
);


//edit actor modal
let EditForm = Form.create({ name: 'edit_form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {
            const {
                visible, onCancel, onCreate, form, eActor, //get all the props from actor
            } = this.props;

            const { getFieldDecorator } = form;
            return (
                <Modal
                    visible={visible}
                    title={"Edit Actor " + eActor.actorGroupName} //the name is different per modal
                    okText="Edit"
                    onCancel={onCancel}
                    onOk={onCreate}
                >
                    <Alert message="Kindly refrain from including periods (.) in the name field." type="info" showIcon />


                    <Form layout="vertical">
                        <Form.Item label="Actor group name">
                            {getFieldDecorator('actorGroupName', {
                                rules: [{ required: true, message: 'Please input the name of actor!' }],
                                initialValue: eActor.actorGroupName //get the oringinal actor name
                            })(
                                <Input />
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
            );
        }
    }
);

//delete representative modal
let DeleteForm = Form.create({ name: 'delete_form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {
            const {
                visible, onCancel, onCreate, form, eActor, //get all the props from actor
            } = this.props;
            let representatives = []
            if (Array.isArray(eActor.actorCriteria) && eActor.actorCriteria.length) {
                if (Array.isArray(eActor.actorCriteria[0].actors) && eActor.actorCriteria[0].actors.length > 0) {
                    eActor.actorCriteria[0].actors.forEach(a => {
                        representatives.push(a.actorEvaluator)
                    })
                }
            }
            let optionsR = []
            representatives.forEach(r => {
                optionsR.push(
                    <Option key={r}>{r}</Option>
                )
            })
            const { getFieldDecorator } = form;
            return (
                <Modal
                    visible={visible}
                    title={"Delete representatives in stakeholder group " + eActor.actorGroupName} //the name is different per modal
                    okText="Finish"
                    onCancel={onCancel}
                    onOk={onCreate}
                >
                    <Form layout="vertical">
                        <Form.Item label="Retain the representatives you wish to keep; all other representatives' data will be removed.">
                            {getFieldDecorator('representatives', {
                                initialValue: representatives,
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please input the name of representatives!'
                                    }
                                ], //set the rule
                            })(
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Select the representatives you wish to keep"
                                // optionLabelProp="label"
                                >
                                    {optionsR}
                                </Select>
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
            );
        }
    }
);

export default class MAMCAActors extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: Cookie.get("email"),
            projectActors: [],
            representativesList: [], // for all representatives
            createVisible: false, //for create modal
            editVisible: false, //for edit modal,
            deleteVisible: false, //for edit modal,
            loading: true, //the loading status default true
            eActor: {}, //for edited alternative
            projectName: "",
            projectType: "",
            licenseType: "Free",
        };
    }

    onStepChange = current => {
        if (current === 0) {
            this.props.history.push(`/alternative/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 2) {
            this.props.history.push(`/mamcacriteria/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 3) {
            this.props.history.push(`/mamcaweight/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 4) {
            this.props.history.push(`/mamcaevaluation/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 5) {
            this.props.history.push(`/mamcaresult/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
    }

    //show or cancel create modal
    showCreateModal = () => {
        this.setState({ createVisible: true });
    }

    handleCreateCancel = () => {
        this.setState({ createVisible: false });
    }

    //show or cancel edit modal
    showEditModal = () => {
        this.setState({ editVisible: true });
    }

    handleEditCancel = () => {
        this.setState({ editVisible: false });
    }

    //show or cancel edit modal
    showDeleteModal = () => {
        this.setState({ deleteVisible: true });
    }

    handleDeleteCancel = () => {
        this.setState({ deleteVisible: false });
    }

    //create actor
    handleCreate = () => {
        const form = this.formRef.props.form; //get all the data from modal
        form.validateFields((err, values) => { //can get values based on name
            if (err || values.actorGroupName.trim().length === 0) { //trim the project name to check the length
                return;
            }
            else {
                fetch('/project/createActor', { //REST create actor
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        uid: this.props.match.params.projectid,
                        actorGroupName: values.actorGroupName.trim(),
                    }),
                }).then(res => res.json())
                    .then(json => {
                        if (json.success) {
                            this.getProjectActors();
                            message.success(json.message); //create successfully, show message
                            this.setState({ createVisible: false }); //make modal invisible
                            form.resetFields(); //reset the form
                        }
                        else {
                            message.error(json.message); //create unsuccessful, show alert
                        }
                    });

            }
        });
    }

    //edit actor
    handleEdit = () => {
        const form = this.EformRef.props.form; //get data from modal
        form.validateFields((err, values) => { //can get values based on name
            if (err || values.actorGroupName.trim().length === 0) {
                return;
            }
            else {
                if (values.actorGroupName.trim() === this.EformRef.props.eActor.actorGroupName) { //no change
                    this.setState({ editVisible: false }); //make modal invisible
                    form.resetFields(); //reset the form
                }
                else {
                    fetch('/project/editActor', { //REST create project
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            uid: this.props.match.params.projectid,
                            actid: this.EformRef.props.eActor._id, //get the id of actor
                            actorGroupName: values.actorGroupName.trim(),
                        }),
                    }).then(res => res.json())
                        .then(json => {
                            if (json.success) {
                                this.getProjectActors();
                                message.success(json.message); //create successfully, show message
                                this.setState({ editVisible: false }); //make modal invisible
                                form.resetFields(); //reset the form
                            }
                            else {
                                message.error(json.message); //create unsuccessful, show alert
                            }
                        });
                }
            }
        });
    }
    //delete representatives
    handleDelete = () => {
        const form = this.DformRef.props.form; //get data from modal
        let initialList = []
        if (Array.isArray(this.state.eActor.actorCriteria) && this.state.eActor.actorCriteria.length) {
            if (Array.isArray(this.state.eActor.actorCriteria[0].actors) && this.state.eActor.actorCriteria[0].actors.length > 0) {
                this.state.eActor.actorCriteria[0].actors.forEach(a => {
                    initialList.push(a.actorEvaluator)
                })
            }
        }
        const areArraysEqual = (arr1, arr2) => {
            if (arr1.length !== arr2.length) return false;

            const sortedArr1 = arr1.slice().sort();
            const sortedArr2 = arr2.slice().sort();

            for (let i = 0; i < sortedArr1.length; i++) {
                if (sortedArr1[i] !== sortedArr2[i]) return false;
            }

            return true;
        };

        form.validateFields((err, values) => { //can get values based on name
            if (areArraysEqual(initialList, values.representatives)) { //no change
                this.setState({ deleteVisible: false }); //make modal invisible
                form.resetFields(); //reset the form
            }
            else {

                const uniqueItems = initialList.filter(item => !values.representatives.includes(item))
                    .concat(values.representatives.filter(item => !initialList.includes(item)));

                fetch('/project/deleteRepresentatives', { //REST create project
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        uid: this.props.match.params.projectid,
                        actid: this.DformRef.props.eActor._id, //get the id of actor
                        representativesToDelete: uniqueItems,
                        representativesToKeep: values.representatives
                    }),
                }).then(res => res.json())
                    .then(json => {
                        if (json.success) {
                            this.getProjectActors();
                            message.success(json.message); //create successfully, show message
                            this.setState({ deleteVisible: false }); //make modal invisible
                            form.resetFields(); //reset the form
                        }
                        else {
                            message.error(json.message); //create unsuccessful, show alert
                        }
                    });
            }
        });
    }
    getUserInformation = () => {
        fetch(`/login/getUserInformation`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: Cookie.get("email"),
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.setState({ //set state
                        licenseType: json.user.licenseinfo.licenseType, //licensetype
                        expire: json.expire,
                        // soon: json.soon
                    });
                }
            });
    }


    //get the actors
    getProjectActors = () => {
        fetch(`/project/getProjectActors/${this.props.match.params.projectid}/${Cookie.get("email")}/`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.setState({
                        projectActors: json.MAMCAActorGroups,
                        projectName: json.projectName,
                        projectType: json.projectType,
                        loading: false
                    }) //save project data
                }
                else {
                    message.error(json.message)
                    this.props.history.push("/"); //redirect to homepage if the project not exist, shouldn't be a case
                }
            });
    }



    deleteActor(actid) { //delete actor
        fetch('/project/deleteActor', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uid: this.props.match.params.projectid,
                actid: actid
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getProjectActors(); //if success, refresh the actor list
                    message.success(json.message); //delete successful, show message
                }
                else {
                    message.error(json.message); //delete unsuccessful, show alert
                }
            });
    }

    //save all the form data of create
    saveFormRef = (formRef) => {
        this.formRef = formRef;
    }
    //save all the form data of edit
    saveEFormRef = (formRef) => {
        this.EformRef = formRef;
    }
    //save all the form data of delete
    saveDFormRef = (formRef) => {
        this.DformRef = formRef;
    }
    checkDisable() {
        if (this.state.projectActors.length < 2) {
            return true
        }
        else {
            return false
        }
    }

    componentDidMount() {
        try {
            this.getProjectActors() //after render immediately get actor list
            this.getUserInformation()
        } catch (e) {
            alert(e);
        }
    }

    render() {
        const Step = Steps.Step;
        //the step infomation
        const mamcaSteps = [{
            title: 'Alternatives',
        },
        {
            title: 'Actors',
        }, {
            title: 'Criteria',
        }, {
            title: 'Weights',
        }, {
            title: 'Evaluation',
        }, {
            title: 'Result',
        }];
        const columns = [{ //the column title of the table
            title: 'Actor Group Name', //the title of column
            dataIndex: 'actorGroupName', //the data index can be used for searching, filtering
            key: 'actorGroupName',
            width: '70%',
        },
        {
            title: 'Action',
            key: 'action',
            width: '30%',
            render: (text, record) => (
                <span>
                    <Link to="#" onClick={() => { this.setState({ eActor: record }); this.showDeleteModal(); }}>Remove representatives</Link>
                    <Divider type="vertical" />
                    {/* save the edited actor data, which will be used later in edit modal, and then show the edit modal */}
                    <Link to="#" onClick={() => { this.setState({ eActor: record }); this.showEditModal(); }}>Edit</Link>
                    <Divider type="vertical" />
                    {/* after comfirmation we can delete the actor */}
                    <Popconfirm title="Are you sure you want to delete this actor?" onConfirm={() => { this.deleteActor(record._id) }} okText="Yes" cancelText="No">
                        <Link to="#">Delete</Link>
                    </Popconfirm>

                </span>
            ),
        }];
        return <div className="MAMCAActors">
            <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                        <h3>{this.state.projectName}</h3>
                </Row>
                <Divider />
                <Steps style={{ width: "80%", margin: "auto" }} current={1} onChange={this.onStepChange}>
                    {mamcaSteps.map(item => <Step key={item.title} title={item.title} />)}
                </Steps>
                <div className="steps-content"></div>
                {this.state.licenseType === "Trial" && this.state.projectActors.length > 2 ?
                    <span>
                        <Button style={{ marginLeft: "0" }} type="primary" size="large" disabled><b>{"\uFF0B\n"}</b> Create a new actor</Button>
                        <Tooltip title="Trial license can only create 3 stakeholder groups">
                            <Badge dot>
                                <Icon style={{ marginLeft: 10 }} type="warning" />
                            </Badge>
                        </Tooltip>
                    </span>

                    :
                    <Button style={{ marginLeft: "0" }} type="primary" size="large" onClick={this.showCreateModal}><b>{"\uFF0B\n"}</b> Create a new actor</Button>
                }


                {/* <Button style={{ marginLeft: "2vh" }} type="primary" size="large" onClick={this.showCreateModal}><Link to={`/mamcasurveysetting/${this.props.match.params.projectid}`}>MAMCA <sup>&copy; </sup> survey</Link></Button> */}
                <div>&nbsp;</div>
                <ConfigProvider renderEmpty={() => { return (<Empty />); }}>
                    <Table columns={columns}
                        rowKey={record => record._id} //unique key needed, so we use mongodb id
                        dataSource={this.state.projectActors} //the data source is what we get after component mount
                    />
                </ConfigProvider>

                <Divider />
                {this.state.projectActors.length < 2 ? <p>You have to create at least two actors to continue</p> : <div />}

                <div className="steps-action">

                    <Button size="large" type="primary" >
                        {/* disabled={this.checkDisable(this.state.project)} */}
                        <Link to={`/mamcacriteria/${this.props.match.params.projectid}`}>Next</Link></Button>
                    <Button size="large" style={{ marginLeft: 8 }}>
                        <Link to={`/alternative/${this.props.match.params.projectid}`}>Previous</Link></Button>
                </div>
            </Spin>
            <CreateForm
                wrappedComponentRef={this.saveFormRef}
                visible={this.state.createVisible}
                onCancel={this.handleCreateCancel}
                onCreate={this.handleCreate}
            />
            <EditForm
                wrappedComponentRef={this.saveEFormRef}
                visible={this.state.editVisible}
                onCancel={this.handleEditCancel}
                onCreate={this.handleEdit}
                eActor={this.state.eActor} //send the edited actor info to the modal
            />
            <DeleteForm
                wrappedComponentRef={this.saveDFormRef}
                visible={this.state.deleteVisible}
                onCancel={this.handleDeleteCancel} // cancel
                onCreate={this.handleDelete}
                eActor={this.state.eActor} //send the edited actor info to the modal
            />
        </div>;
    }
}